import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { UpdateSection } from "../../../../redux/services/ContentService/content.Services";
import { successToast, errorToast } from "../../../../Utils/toast";

function EditSection() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("editSection");
    if (!stored) {
      navigate("/sections-list");
      return;
    }
    const data = JSON.parse(stored);
    setForm({
      id: data.id,
      section_key: data.section_key || "",
      title: data.title || "",
      subtitle: data.subtitle || "",
      description: data.description || "",
      image: data.image || "",
      type: data.type || "hero",
      sort_order: data.sort_order ?? 0,
      status: data.status ?? 1,
    });
  }, [navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await UpdateSection(form);

      if (res?.success) {
        successToast(res?.message || "Section updated successfully!");
        localStorage.removeItem("editSection");
        navigate("/sections-list");
      } else {
        errorToast(res?.message || "Failed to update section");
      }
    } catch (err) {
      console.log(err);
      errorToast(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  if (!form) return <div className="p-4">Loading...</div>;

  return (
    <div>
      <div className="d-md-flex d-block align-items-center justify-content-between mt-1 page-header-breadcrumb">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="page-header">
            <div>
              <h3 className="page-title mb-0">Edit Section</h3>
              <nav className="page-breadcrumb">
                <Link to="/">Home</Link>
                <span className="mx-2">/</span>
                <Link to="/module-list">Modules</Link>
                <span className="mx-2">/</span>
                <Link to="/solutions-list">Solutions</Link>
                <span className="mx-2">/</span>
                <Link to="/sections-list">Sections</Link>
                <span className="mx-2">/</span>
                <span>Edit</span>
              </nav>
            </div>
          </div>

          <Link
            to="/sections-list"
            className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
            style={{ width: "40px", height: "40px", borderRadius: "8px" }}
          >
            <FaArrowLeft />
          </Link>
        </div>
      </div>

      <div className="main_page">
        <div className="st-wrapper-card p-4">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Section Key</label>
                <input
                  type="text"
                  name="section_key"
                  value={form.section_key}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Type *</label>
                <select
                  name="type"
                  value={form.type}
                  onChange={handleChange}
                  className="form-control"
                  required
                >
                  <option value="hero">Hero</option>
                  <option value="content">Content</option>
                  <option value="card_grid">Card Grid</option>
                  <option value="icon_list">Icon List</option>
                  <option value="feature_grid">Feature Grid</option>
                  <option value="image_text">Image Text</option>
                  <option value="faq">FAQ</option>
                  <option value="form">Form</option>
                  <option value="cta">CTA</option>
                  <option value="stats">Stats</option>
                </select>
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  name="title"
                  value={form.title}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label">Subtitle</label>
                <input
                  type="text"
                  name="subtitle"
                  value={form.subtitle}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label">Description</label>
                <textarea
                  name="description"
                  value={form.description}
                  onChange={handleChange}
                  className="form-control"
                  rows="3"
                ></textarea>
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label">Image URL</label>
                <input
                  type="text"
                  name="image"
                  value={form.image}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>

            <div className="d-flex justify-content-end gap-2 mt-3">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate("/sections-list")}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? "Updating..." : "Update Section"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EditSection;